import { call, put, takeLatest, select } from 'redux-saga/effects';
import { get } from 'lodash';
import pickBy from 'lodash/pickBy';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { getSortParams } from '../helpers/utils';
import {
  FETCH_ARCHIVE_SOLD,
  FETCH_ARCHIVE_SOLD_FAIL,
  FETCH_ARCHIVE_SOLD_SUCCESS
} from '../redux/ArchiveTables';
import { SET_LOADER } from '../redux/Loader';
import { SOLD } from '../consts/navigation';

function* fetchArchiveSoldFlow() {
  try {
    yield put(SET_LOADER({ value: true, }));
    const sortData = yield select((state) => get(state, ['tables', SOLD, 'sort']));
    const queryValue = yield select((state) => get(state, ['tables', SOLD, 'queryValue']));
    const limitValue = yield select((state) => get(state, ['tables', SOLD, 'rowsPerPage']));
    const page = yield select((state) => get(state, ['tables', SOLD, 'page']));
    const vehicleType = yield select((state) => state.vehicleType.vehicleType);

    const params = pickBy(
      {
        ...getSortParams(sortData),
        query: queryValue,
        limit: limitValue,
        page,
      },
      (val) => Boolean(val)
    );

    const endpoint = `${apiRoot}/${vehicleType}/archive_offers/sold`;
    const data = yield call(apiCall, { method: 'GET', endpoint, params, });
    yield put(FETCH_ARCHIVE_SOLD_SUCCESS(data));
  } catch (error) {
    yield put(FETCH_ARCHIVE_SOLD_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* fetchArchiveSold() {
  yield takeLatest(FETCH_ARCHIVE_SOLD, fetchArchiveSoldFlow);
}
